import { render, staticRenderFns } from "./FTPInformation.vue?vue&type=template&id=04b622bf&scoped=true"
import script from "./FTPInformation.vue?vue&type=script&lang=js"
export * from "./FTPInformation.vue?vue&type=script&lang=js"
import style0 from "./FTPInformation.vue?vue&type=style&index=0&id=04b622bf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b622bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04b622bf')) {
      api.createRecord('04b622bf', component.options)
    } else {
      api.reload('04b622bf', component.options)
    }
    module.hot.accept("./FTPInformation.vue?vue&type=template&id=04b622bf&scoped=true", function () {
      api.rerender('04b622bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customerManagements/CustomerList/cmp/FTPInformation.vue"
export default component.exports